module.exports = __webpack_public_path__ + "static/media/32_plantilla_rec_combo_simple_cf_gaseosas_pet_2_5_ccso.9bb16f2d.png";